import { heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  const handleNavClick = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] lg:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 lg:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-6">
              <i className="ri-flashlight-line text-sm"></i>
              <span>吃瓜网站最新线路已更新</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-900 leading-tight mb-5">
              吃瓜网站
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-500 mt-2">
                最全娱乐资讯导航入口
              </span>
            </h1>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              吃瓜网站✨官方线路一及备用入口大全，提供吃瓜网站在线观看与首页直达访问。
              覆盖吃瓜网站最新线路与稳定入口，解决访问稳定性问题，快速进入吃瓜网站首页。
              每日更新海量娱乐资讯，涵盖明星动态、影视综艺、社会热点等全领域内容，
              搭配多条智能线路保障，让您随时随地畅享流畅的吃瓜体验。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleNavClick('ranking')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-semibold rounded-full text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                查看热度排行
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => handleNavClick('index')}
                className="w-full sm:w-auto px-8 py-3 bg-background-100 text-foreground-800 font-medium rounded-full text-sm hover:bg-background-200 transition-all duration-200 cursor-pointer whitespace-nowrap border border-background-300/60"
              >
                浏览主题索引
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] md:w-[360px] md:h-[360px] lg:w-[420px] lg:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20minimal%20flat%20illustration%20of%20a%20watermelon%20slice%20with%20abstract%20geometric%20shapes%20surrounding%20it%2C%20warm%20coral%20red%20and%20fresh%20green%20color%20palette%2C%20clean%20white%20background%2C%20playful%20yet%20sophisticated%20design%2C%20editorial%20illustration%20style%2C%20soft%20shadows%2C%20modern%20art%20direction%2C%20bright%20and%20energetic%20composition%20with%20news%20and%20entertainment%20elements%20like%20stars%20and%20speech%20bubbles%20subtly%20integrated&width=840&height=840&seq=hero-main-visual&orientation=squarish"
                alt="吃瓜网站 - 娱乐资讯导航入口"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}